import React from 'react';
import { HeaderWrapper } from '../../Header';
import { HeaderEH } from '../../Header';
import SEO from '../../SEO';
import { useIntl } from 'react-intl';
import { Footer } from '../../Footer';
import { Grid } from '@amzn/awsui-components-react';
import { getEHLocationValue } from '../../../utils/configureAmplify';
import messages from './ReInventLandingPage.messages';
import './ReInventLandingPage.scss';
import CustomEventContainer from './CustomEventContainer';
import CustomSignInContainer from './CustomSignInContainer';

const reInventComponents = {
  signInOptions: {
    primarySignInOption: 'OTP',
    secondarySignInOptions: ['AWSBuilderID'],
  },
  customContent: [],
};

const ReInventLandingPage = () => {
  const eventName = 'reInvent23';
  const { formatMessage } = useIntl();
  return (
    <div className="ReInventLandingPage__wrapper">
      <SEO title={formatMessage(messages.seoTitle)} />
      <HeaderWrapper>
        <HeaderEH
          isAuthenticated={false}
          isStandalone={true}
          isOutsideRouter={true}
        />
      </HeaderWrapper>
      <div
        className="ReInventLandingPage__content"
        id="js-main-content"
        tabIndex="-1"
        style={{ outline: 'none' }}
      >
        <Grid
          disableGutters
          gridDefinition={[
            {
              colspan: {
                default: 12,
                m: 5,
                l: 4,
                xl: 3,
              },
            },
            {
              colspan: {
                default: 12,
                m: 6,
                xl: 4,
              },
            },
          ]}
        >
          <CustomEventContainer
            eventName={eventName}
            components={reInventComponents}
          />

          <CustomSignInContainer
            primarySignInOption={
              reInventComponents.signInOptions.primarySignInOption
            }
            secondarySignInOptions={
              reInventComponents.signInOptions.secondarySignInOptions
            }
            customHelp={getEHLocationValue() ? true : false}
            customHelpMessage={formatMessage(messages.reInventCustomHelp)}
          />
        </Grid>
      </div>
      <Footer
        isStandalone
        isOutsideRouter
        // Update to use AppLayout for the Landing Page: https://sim.amazon.com/issues/EventHorizon-3536
        appLayoutRef={{}}
      />
    </div>
  );
};

export { ReInventLandingPage, reInventComponents };
